var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2962 18.7576C24.3309 16.0537 25.7774 13.4951 28.0722 12.0788C26.6245 10.0033 24.1998 8.68729 21.6771 8.60806C18.9864 8.32453 16.378 10.2244 15.0069 10.2244C13.6092 10.2244 11.4982 8.63621 9.22495 8.68316C6.26188 8.77926 3.49956 10.4705 2.05797 13.0711C-1.04089 18.4572 1.27058 26.373 4.23903 30.7268C5.7242 32.8587 7.45995 35.2401 9.73113 35.1556C11.9536 35.0631 12.7837 33.7329 15.4664 33.7329C18.1243 33.7329 18.903 35.1556 21.2203 35.1019C23.6051 35.0631 25.1077 32.9605 26.5408 30.8085C27.6079 29.2894 28.429 27.6105 28.9737 25.834C26.1711 24.644 24.2995 21.8125 24.2962 18.7576Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9193 5.74482C21.2196 4.17775 21.8602 2.16355 21.7051 0.129955C19.7185 0.339423 17.8834 1.29259 16.5655 2.79954C15.2768 4.2719 14.6062 6.25066 14.733 8.20653C16.7203 8.22707 18.674 7.29974 19.9193 5.74482Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreIcon);
export default __webpack_public_path__ + "static/media/AppStoreIcon.1175f7ca731a63f438d82e95329b6181.svg";
export { ForwardRef as ReactComponent };